import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/gif-outline.vue
var o = {
	name: "DtIconGifOutline",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--gif-outline"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Gif Outline",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7ZM2.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm0 4A1.5 1.5 0 0 1 4 4.5h.5a.5.5 0 1 1 0 1H4a.5.5 0 0 0-.5.5v.5A.5.5 0 0 0 4 7v-.316a.5.5 0 0 1 .25-.934h.25a.5.5 0 0 1 .5.5V7.5a.5.5 0 0 1-.5.5H4a1.5 1.5 0 0 1-1.5-1.5V6ZM6 4.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 1 1-1 0V5a.5.5 0 0 1 .5-.5ZM7 5a.5.5 0 0 1 .5-.5H9a.5.5 0 1 1 0 1H8v.25h.5a.5.5 0 1 1 0 1H8v.75a.5.5 0 1 1-1 0V5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=gif-outline.js.map